import styled from 'styled-components';

export const Label = styled.div`
    font-size: 16px;
    font-weight: 600;
`;
